import React from "react";
import DropdownValuesSetup from "../pages/dropdown_options/DropdownValuesSetup";
import FacilityDropdownValue from "../pages/dropdown_options/FacilityDropdownValue";

function FacilityDropdownWithCustomModal({ dropdownName, onClose }) {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Add/Edit Options</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <FacilityDropdownValue
                dropdownName={dropdownName}
                isReadOnly={true}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default FacilityDropdownWithCustomModal
